import React from 'react';
import './Menu.scss';
import { Link } from 'react-router-dom';

const Menu = () => {
  const menu = [
    {
      id: 1,
      name: 'new',
      slug: 'newest',
    },
    {
      id: 2,
      name: 'ask',
      slug: 'ask',
    },
    {
      id: 3,
      name: 'show',
      slug: 'show',
    },
    {
      id: 4,
      name: 'jobs',
      slug: 'jobs',
    },
  ];

  const renderMenu = () => {
    return menu.map((item, idx) => {
      return (
        <React.Fragment key={`menu-${idx}`}>
          <Link to={`/${item.slug}`}>{item.name}</Link>
          {idx !== menu.length - 1 && <span>|</span>}
        </React.Fragment>
      );
    });
  };
  return <nav>{renderMenu()}</nav>;
};

export default Menu;
